import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, Output, inject } from '@angular/core';
import { MessageThread } from '@nano/common/message';
import { CONFIG } from '@nano/core/config';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { NzSizeLDSType } from 'ng-zorro-antd/core/types';

@Component({
  selector: 'app-message-thread-list',
  templateUrl: './message-thread-list.component.html',
  styleUrls: ['./message-thread-list.component.less'],
  standalone: false
})
export class MessageThreadListComponent implements AfterViewInit {
  @Output() messageSelected: EventEmitter<string> = new EventEmitter<string>();

  @Input() messageThreads: MessageThread[];
  @Input() selectedMessageThreadId?: string;
  @Input() size?: NzSizeLDSType = 'default';

  readonly split: boolean;
  readonly bankName: string;

  private config = inject(CONFIG);

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private elementRef: ElementRef
  ) {
    this.split = this.config.messageThreadListSplit;
    this.bankName = this.config.bankName;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.scrollToSelectedItem());
  }

  scrollToSelectedItem(): void {
    const nativeElement = this.elementRef.nativeElement as HTMLElement;
    const selectedItem = nativeElement.querySelector('.app-message-thread-list-item-selected');

    if (selectedItem) {
      // Necessary for scrolling to selected item [DEV-13814] - added block: 'nearest' and inline: 'nearest' to minimize recalculations
      // eslint-disable-next-line @rx-angular/prefer-no-layout-sensitive-apis
      selectedItem.scrollIntoView({
        block: 'nearest',
        inline: 'nearest'
      });
    }
  }
  get displayFrom(): boolean {
    return this.size !== 'small';
  }

  isMessageThreadSelected(id: string): boolean {
    return id === this.selectedMessageThreadId;
  }

  selectMessageThread(id: string): void {
    this.selectedMessageThreadId = id;
    this.messageSelected.emit(id);
  }
}
